import { PaymentStateEnum } from './payment-state.enum';
import { PblLiabilityPaymentStatusEnum } from './pbl-payment-status.enum';
import { PaymentMethod } from './payment-method.model';

export class LiabilityDataModel {
  amountToPay: number;
  biller: string;
  brandId: string;
  commission: number;
  name: string;
  surname: string;
  customer: string;
  paymentState: PaymentStateEnum;
  paymentStatus: PblLiabilityPaymentStatusEnum;
  totalAmount: number;
  email: string;
  title: string;
  balance: BalanceDataModel;
  integrationVersion?: IntegrationVersionEnum;
  availablePaymentMethods: PaymentMethod[];
  availableBillGatewayApps: string[];
  accountLinked: boolean;
}

export class BalanceDataModel {
  enabled: boolean;
  amountToPay: number;
  commission: number;
  totalAmount: number;
  items: BalanceItemModel[];
}

export class BalanceItemModel {
  title: string;
  amount: number;
  paymentDue: string;
  status: BalanceItemPaymentStatus;
}

export enum BalanceItemPaymentStatus {
  OVERDUE = 'OVERDUE',
  NOT_OVERDUE = 'NOT_OVERDUE'
}

export enum IntegrationVersionEnum {
  V0 = 'V0',
  V1 = 'V1'
}
